import { Routes, Route } from 'react-router-dom';
import { S3Console } from './S3Console';
import { StorageLanding } from './StorageLanding';
import { StorageOnboardingWizard } from './StorageOnboardingWizard';

/**
 * Object Storage (S3-compatible / MinIO) module.
 *
 *   /services/oss              → landing gate: redirect to console if activated,
 *                               else the activation hero (mirrors cert-inventory)
 *   /services/oss/onboarding   → guided setup wizard (activate → bucket → policy → key)
 *   /services/oss/:serviceId   → console for that storage service
 */
export function S3Page() {
  return (
    <Routes>
      <Route index element={<StorageLanding />} />
      <Route path="onboarding" element={<StorageOnboardingWizard />} />
      <Route path=":serviceId/*" element={<S3Console />} />
    </Routes>
  );
}

export default S3Page;
